import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['startDate', 'endDate', 'wrongDuration'];

  static values = {
    duration: Number,
  };

  connect() {
    this.setEndDateMaximumDuration();
    this.validateDuration();
  }

  setEndDateMaximumDuration() {
    if (!this.startDateTarget.value || this.durationValue === 0) {
      return;
    }

    const [startYear, startMonth, startDay] = this.startDateTarget.value.split('-');
    const monthFactor = (Number(startMonth) + this.durationValue) % 12;
    const yearAddFactor = Math.floor((Number(startMonth) + this.durationValue) / 12);

    const maxEndDate = new Date(Number(startYear) + yearAddFactor, monthFactor - 1, Number(startDay), 1)
      .toISOString()
      .split('T')[0];
    this.endDateTarget.setAttribute('max', maxEndDate);
  }

  validateDuration() {
    if (!this.startDateTarget.value || !this.endDateTarget.value || this.durationValue === 0) {
      return;
    }

    const [startYear, startMonth, startDay] = this.startDateTarget.value.split('-');
    const [endYear, endMonth, endDay] = this.endDateTarget.value.split('-');

    const yearDifferenceInMonths = (Number(endYear) - Number(startYear)) * 12;
    const monthDifference = Number(endMonth) - Number(startMonth);
    const dayDifference = Number(endDay) - Number(startDay);

    let durationInMonths = yearDifferenceInMonths + monthDifference;

    // it does not hit the end date, day which is good
    // it means the month difference can be considered
    // it goes above the month difference which means we can add a fake month
    // and indicate the range to be more in the view
    if (dayDifference > 0) {
      durationInMonths += 1;
    }

    if (durationInMonths > this.durationValue) {
      this.showFailedValidationMessage();
    } else {
      this.removeFailedValidationMessage();
    }
  }

  showFailedValidationMessage() {
    const message = `Duration is more than ${this.durationValue} months`;
    this.startDateTarget.classList.add('border-danger');
    this.endDateTarget.classList.add('border-danger');

    this.startDateTarget.setCustomValidity(message);
    this.endDateTarget.setCustomValidity(message);
    this.wrongDurationTarget.textContent = message;

    this.wrongDurationTarget.classList.remove('d-none');
  }

  removeFailedValidationMessage() {
    this.startDateTarget.classList.remove('border-danger');
    this.endDateTarget.classList.remove('border-danger');

    this.startDateTarget.setCustomValidity('');
    this.endDateTarget.setCustomValidity('');
    this.wrongDurationTarget.textContent = '';
    this.wrongDurationTarget.classList.add('d-none');
  }
}
